import { Injectable } from '@angular/core'
import { Product } from '../models/product'
import { User } from '../models/user'
import { Card } from '../models/card'
import { Contract } from '../models/contract'

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public empty_product: Product = {
    CARRIER: '',
    CHANNEL: '',
    COLOR: '',
    COMPANY: '',
    DEALERNETASSURANT: '',
    DEALERNETASURION: 0,
    DISPLAYMODELNAME: '',
    LAUNCHDATE: '',
    MEMORY: '',
    MODELCODE: '',
    MODELFAMILY: '',
    MODELTYPE: '',
    MSRP: 0,
    PAYMENTFREQUENCY: '',
    PBHIGH: 0,
    PBLOW: 0,
    PRICE: 0,
    PROGRAM: '',
    RENEWALSKU: '',
    SKU: '',
    SVCPACKSKU: '',
    TERM: '',
    SKUDESC: '',
    TICKETNO: '',
    ASCNO: '',
    TECHNICIANID: '',
    STATUS: '',
    DISCOUNTAMOUNT: 0,
  }
  public empty_user: User = {
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    locality: '',
    administrativeArea: '',
    postalCode: '',
    country: '',
    email: '',
    phoneNumber: '',
    phoneNumber2: ''
  }
  public empty_card: Card = {
    number: '',
    securityCode: '',
    expirationMonth: '',
    expirationYear: ''
  }
  public empty_contract: Contract = {
    cancelAvailable: false,
    contractEndDate: '',
    contractNo: '',
    contractStartDate: '',
    email: '',
    firstName: '',
    lastName: '',
    modelCode: '',
    modelType: '',
    orderDate: '',
    purchaseDate: '',
    serialNo: '',
    spcPrice: '',
    spcSku: '',
    status: '',
    term: '',
    contractStatus: '',
    skudesc: '',
    cancelDesc: '',
    retailitemAmt: ''
  }

  public agentId: string = ''
  public storename: string = ''
  public price: number = 0
  public tax: number = 0
  public taxrate: number = 0
  public total: number = 0
  public modelCode: string = ''
  public serialNumber: string = ''
  public ticketNo: string = ''
  public technicianID: string = ''
  public ascNo: string = ''
  public discountAmount: number = 0
  public status: string = ''
  public policyNumber: string = ''
  public email: string = ''
  public product: Product = this.empty_product
  public user: User = this.empty_user
  public card: Card = this.empty_card
  public contract: Contract = this.empty_contract
  public products: Product[] = []

  public isRecaptchaSuccess: boolean = false
  public recaptchaSiteKey: string = '6Lf7J3oaAAAAAI1OA9f1eyP6Mk3XykDIo9pvEEMc'

  constructor() {
  }

  public resetData(): void {
    this.price = 0
    this.tax = 0
    this.taxrate = 0
    this.total = 0
    this.modelCode = ''
    this.serialNumber = ''
    this.policyNumber = ''
    this.email = ''
    this.product = this.empty_product
    this.user = this.empty_user
    this.card = this.empty_card
    this.contract = this.empty_contract
    this.products = []
  }

  public getTestData(): void {
    this.isRecaptchaSuccess = true
    this.modelCode = 'UN43TU7000FXZA'
    this.serialNumber = '09LJ3CGN817816Z'
    this.policyNumber = '643014474'
    this.email = 'yisangho717@gmail.com'
    this.product = {
      CARRIER: null,
      CHANNEL: 'CEPOS',
      COLOR: null,
      COMPANY: 'C310',
      DEALERNETASSURANT: null,
      DEALERNETASURION: 163.75,
      DISPLAYMODELNAME: '(4) Expand Premium w/ QLED',
      LAUNCHDATE: '2020',
      MEMORY: null,
      MODELCODE: 'QN85Q90TAFXZA',
      MODELFAMILY: 'LED',
      MODELTYPE: 'Televisions',
      MSRP: 5299.99,
      PAYMENTFREQUENCY: 'SINGLEPAY',
      PBHIGH: 5999.99,
      PBLOW: 4000,
      PRICE: 190.41,
      PROGRAM: 'DaaS',
      RENEWALSKU: null,
      SKU: 'LD-DOP36L-PB6-L00',
      SVCPACKSKU: 'P-UT-3XXX600C',
      TERM: '36',
      SKUDESC: 'TEST',
      TICKETNO: '4123450909',
      ASCNO: '0000',
      TECHNICIANID: '0000',
      STATUS: 'ST052',
      DISCOUNTAMOUNT: 10,
    }
    this.user = {
      firstName: 'John',
      lastName: 'Doe',
      address1: '1 Market St',
      address2: '',
      locality: 'San Francisco',
      administrativeArea: 'CA',
      postalCode: '94105',
      country: 'US',
      email: 'wooick.c@samsung.com',
      phoneNumber: '4158880000',
      phoneNumber2: '1234567890'
    }
    this.card = {
      number: '4111111111111111',
      securityCode: '123',
      expirationMonth: '12',
      expirationYear: '2031'
    }
  }

  keyPressNumbersOnly(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  keyPressAlphabetsOnly(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericOnly(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 47 && charCode < 58) || (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressAlphaNumericSpaceOnly(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode == 32) || (charCode > 47 && charCode < 58) || (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  blockRefresh() {
    function helper(e: any) {
      if ((e.which || e.keyCode) == 116
        || ((e.which || e.keyCode) == 116 && e.ctrlKey)
        || ((e.which || e.keyCode) == 82 && e.ctrlKey)) {
        e.preventDefault();
      }
    }

    window.addEventListener('keyup', helper);
    window.addEventListener('keydown', helper);
  }
}
